import produce from 'immer';
import { AnyAction } from 'redux';
import {
  FETCH_USER_ERROR,
  FETCH_USER_LOADING,
  SET_USER_DATA,
  UPDATE_USER_ERROR
} from '../ActionTypes';
import { ICustomer } from 'interfaces';

type InitialStateType = {
  loading: boolean;
  loaded: boolean;
  authorized: boolean;
  error: string | null;
  data: ICustomer | null;
};

const storageUser = localStorage.getItem('userData');
const tokenInStorage = !!localStorage.getItem('token');

export const INIT_STATE: InitialStateType = {
  authorized: tokenInStorage,
  loading: tokenInStorage,
  loaded: !!storageUser,
  error: null,
  data: storageUser ? JSON.parse(storageUser) : null
};

export const userReducer = (
  state = INIT_STATE,
  action: AnyAction
): InitialStateType =>
  produce(state, draft => {
    switch (action.type) {
      case FETCH_USER_LOADING:
        draft.loading = action.payload;
        draft.error = null;
        break;

      case SET_USER_DATA: {
        if (!action.payload) {
          localStorage.removeItem('userData');
        } else {
          localStorage.setItem('userData', JSON.stringify(action.payload));
        }
        draft.loading = false;
        draft.loaded = !!action.payload;
        draft.data = action.payload;
        break;
      }

      case FETCH_USER_ERROR:
        draft.loading = false;
        draft.loaded = false;
        draft.error = action.payload;
        draft.data = null;
        localStorage.removeItem('userData');
        break;

      case UPDATE_USER_ERROR:
        draft.loading = false;
        draft.loaded = true;
        draft.error = action.payload;
        break;
    }
  });
